module.exports = __webpack_public_path__ + "img/1545219981.8a0fe5bc.jpg";